// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReceptionOperationsCont{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.action-reception-btn{
    margin: 10px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    border-radius: 10px;
    padding: 7px;
    width: 130px;
    font-size: 10pt;
    text-align: center;
    font-weight: 500;
    color: #ffffff;
    border: none;
}
.copyBtn {
    background: transparent; /* רקע שקוף */
    border: none; /* ללא מסגרת */
    cursor: pointer;
    padding: 5px; /* ריווח מינימלי */
    display: flex;
    align-items: center;
    justify-content: center;
}

.copyBtn:hover {
    background: rgba(0, 0, 0, 0.1); /* רקע עדין במעבר */
    border-radius: 5px;
}
.btn-cont-reception{
    display: flex;
    direction: rtl;
}

.endTreatBtn{
    width: 50%;
    background-color: #ffffff;
    border-radius: 100px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    padding: 8px 20px 8px 20px;
    border: 1px dashed red;
    margin: 15px;
}

.endTreatBtn:hover{
    background-color: #ffebeb;
 
}`, "",{"version":3,"sources":["webpack://./src/components/DoctorPage/ReceptionOperations.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;AACA;IACI,uBAAuB,EAAE,aAAa;IACtC,YAAY,EAAE,cAAc;IAC5B,eAAe;IACf,YAAY,EAAE,kBAAkB;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B,EAAE,mBAAmB;IACnD,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;;AAE7B","sourcesContent":[".ReceptionOperationsCont{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.action-reception-btn{\r\n    margin: 10px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    padding: 7px;\r\n    width: 130px;\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    color: #ffffff;\r\n    border: none;\r\n}\r\n.copyBtn {\r\n    background: transparent; /* רקע שקוף */\r\n    border: none; /* ללא מסגרת */\r\n    cursor: pointer;\r\n    padding: 5px; /* ריווח מינימלי */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.copyBtn:hover {\r\n    background: rgba(0, 0, 0, 0.1); /* רקע עדין במעבר */\r\n    border-radius: 5px;\r\n}\r\n.btn-cont-reception{\r\n    display: flex;\r\n    direction: rtl;\r\n}\r\n\r\n.endTreatBtn{\r\n    width: 50%;\r\n    background-color: #ffffff;\r\n    border-radius: 100px;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 20px 8px 20px;\r\n    border: 1px dashed red;\r\n    margin: 15px;\r\n}\r\n\r\n.endTreatBtn:hover{\r\n    background-color: #ffebeb;\r\n \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
